var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconActionCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/action/check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.66594783,16.8626196 C9.57749384,16.8626196 9.49641102,16.8478772 9.42269936,16.8183926 C9.34898771,16.7889079 9.27527605,16.7373098 9.20156439,16.6635981 L5.19902147,12.6610552 C5.06634049,12.5283742 5,12.3662086 5,12.1745583 C5,11.9829079 5.06634049,11.8207423 5.19902147,11.6880613 C5.33170245,11.5553803 5.48649693,11.4890399 5.6634049,11.4890399 C5.84031288,11.4890399 5.99510736,11.5553803 6.12778834,11.6880613 L9.66594783,15.2262208 L17.6931472,7.19902147 C17.8258281,7.06634049 17.9843082,7 18.1685873,7 C18.3528665,7 18.5113465,7.06634049 18.6440275,7.19902147 C18.7767085,7.33170245 18.843049,7.49018251 18.843049,7.67446165 C18.843049,7.85874079 18.7767085,8.01722085 18.6440275,8.14990183 L10.1303313,16.6635981 C10.0566196,16.7373098 9.98290795,16.7889079 9.90919629,16.8183926 C9.83548463,16.8478772 9.75440181,16.8626196 9.66594783,16.8626196 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/action/check"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Neutral-Fill",
    mask: "url(#mask-2)",
    fill: "#005082"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Fill",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActionCheck);
export default __webpack_public_path__ + "static/media/icon_action_check.131b6ee7377daf8e95795b0e108b8d0a.svg";
export { ForwardRef as ReactComponent };